import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../common/button/Button';
import Checkbox from '../../common/inputs/checkbox/Checkbox';

import './my-preferences.scss';

const MyPreferences = ({ preferences, updatePreference, savePreferences }) => {
  const checkPreference = (name) => {
    const preference = preferences.find((preference) => preference.name === name);
    return preference && preference.value === 'true';
  };

  return (
    <section className="my-preferences">
      <h1 className="my-preferences__header">My Preferences</h1>

      <section className="my-preferences__preferences">
        <div className="my-preferences__preference">
          <p className="my-preferences__preference__header">Notification Permissions</p>
          <div className="my-preferences__preference__body">
            <Checkbox
              value={checkPreference('email notifications enabled')}
              onChange={() => updatePreference('email notifications enabled')}
            />
            <span className="my-preferences__preference__description">
              <p>Receive e-mail notifications.</p>
            </span>
          </div>
        </div>

        <div className="my-preferences__preference">
          <p className="my-preferences__preference__header">Contact Permissions</p>
          <div className="my-preferences__preference__body">
            <Checkbox
              value={checkPreference('direct contact allowed')}
              onChange={() => updatePreference('direct contact allowed')}
            />
            <span className="my-preferences__preference__description">
              <p>Make my account visible so other users can contact me directly through the app.</p>
              <p>(This does not include your contact details, only facilitated communication in this app.)</p>
            </span>
          </div>
        </div>

        <div className="my-preferences__preference">
          <p className="my-preferences__preference__header">Marketing Permissions</p>
          <div className="my-preferences__preference__body">
            <Checkbox
              value={checkPreference('subscribe to marketing emails')}
              onChange={() => updatePreference('subscribe to marketing emails')}
            />
            <span className="my-preferences__preference__description">
              <p>Subscribe to marketing e-mail communications.</p>
            </span>
          </div>
        </div>
      </section>

      <section className="my-preferences__buttons">
        <Button onClick={savePreferences}>Save Changes</Button>
      </section>
    </section>
  );
};

MyPreferences.propTypes = {
  preferences: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updatePreference: PropTypes.func.isRequired,
  savePreferences: PropTypes.func.isRequired,
};

export default MyPreferences;
